import { useEffect, useState } from "react";
import { useParams, Outlet } from "react-router-dom";
import SidebarLayout from "../../components/common/layout/SidebarLayout";
import { projectMenus } from "../../components/layout/ProjectMenus";
import { getContractStatistics } from "../../api/contract/statistics";

const ContractLayout = () => {
  const { id: projectId } = useParams();
  const [counts, setCounts] = useState({ construction: {}, sub: {} });

  // 계약 통계 로딩
  useEffect(() => {
    if (!projectId) return;
    async function fetchCounts() {
      try {
        const data = await getContractStatistics(projectId);
        setCounts(data);
      } catch (e) {
        console.error("계약 통계 불러오기 실패:", e);
      }
    }
    fetchCounts();
  }, [projectId]);

  // ProjectMenus에서 가져오기
  const { title, base, sections } = projectMenus.contract;

  return (
    <SidebarLayout
      title={title}
      base={base}
      sections={sections}
    >
      <Outlet />
    </SidebarLayout>
  );
};

export default ContractLayout;
